import React from "react";
import { ReactComponent as Green } from "../assets/oval_green.svg";
import { ReactComponent as Orange } from "../assets/oval_orange.svg";
import { ReactComponent as Red } from "../assets/oval_red.svg";
import { TOrderStatus } from "../types/bundle.types";
import { capitalize } from "./utils";
import classNames from "classnames";

const ORDER_STATUS_TO_INDICATOR: Record<TOrderStatus, React.ReactNode> = {
    active: <Green />,
    pending: <Orange />,
    suspended: <Red />,
    suspended_pending: <Red />,
    deleted: <Red />,
}

const OrderStatusIndicator = (props: { status: TOrderStatus, className?: string }) => {
    const icon = ORDER_STATUS_TO_INDICATOR[props.status];
    return (
        <div className={classNames("order-status-indicator", props.className)}>
            {icon} {capitalize(props.status)}
        </div>
    )
};

export default OrderStatusIndicator;
